import React, {useRef, useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {featureInterface} from "./featureInterface";
import {getFeatureEditPermission, getFilteredFeatures} from "../featuresFunctions";
import {featuresSetupUpdateFeature} from "../featuresActions";
import {SHIPPING_TIMES} from "../../../utilities";
import Select5 from "../../Generic/Select5";
import TextInput from "../../Generic/textInput";


const FeaturesSetupFeatureContentShippingTimeSelect = (props) => {

  const {feature, intl, canEdit, allOptions, featuresSetupUpdateFeature} = props;

  const [useCustomInput, setUseCustomInput] = useState(false);
  const shippingInput = useRef();

  const onItemClick = (selectOption, isBlur) => {
    if (!canEdit) {
      return false
    }
    if (selectOption.value === "Custom") {
      setUseCustomInput(true);
      featuresSetupUpdateFeature(feature, 'shippingTime', "");
      setTimeout(() => {
        if (shippingInput && shippingInput.current && shippingInput.current.refs && shippingInput.current.refs.inputElement) {
          shippingInput.current.refs.inputElement.focus()
        }
      }, 0)
      return false
    }
    featuresSetupUpdateFeature(feature, 'shippingTime', selectOption.value);
    if (isBlur && useCustomInput) {
      setUseCustomInput(false)
    }
  }

  if (useCustomInput) {
    return (
      <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-left" + (canEdit ? "" : " ui-input--gray4--disabled")}
                 placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.shippingTime"})}
                 ref={shippingInput}
                 readonly={!canEdit}
                 onChange={(value, isBlur) => onItemClick({value}, isBlur)}
                 value={feature.shippingTime}/>
    )
  }

  const selectedItem = allOptions.find(item => item.value === feature.shippingTime);

  return (
    <Select5 selectItems={allOptions}
             selectItemClick={onItemClick}
             selectedItem={selectedItem}
             placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.shippingTime"})}
             className={"select5--units"}
             maxItems={6} />
  )
};

FeaturesSetupFeatureContentShippingTimeSelect.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {canEdit} = getFeatureEditPermission(store);
  const featuresList = getFilteredFeatures(store, false, false);

  const allOptions = [...new Set([
    ...SHIPPING_TIMES,
    ...featuresList.filter(feature => feature && feature.shippingTime).map(feature => feature.shippingTime),
    "Custom"
  ])].map(option => ({
    value: option,
    label: option
  }));

  return {
    canEdit,
    allOptions,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureContentShippingTimeSelect)
)
